<template>
	<teleport to="body">
	<div v-if="open" class="feature-comparison-modal-overlay" v-on:click.self="$emit('close')">
		<div class="feature-comparison-modal-container">
			<button class="feature-comparison-modal-close" v-on:click="$emit('close')">×</button>
			<div class="feature-comparison-modal-content">
				<div class="feature-comparison-table">
					<div class="table-header">
						<div class="header-row">
							<div class="header-cell header-cell--empty"></div>
							<div v-for="plan in plans" :key="plan" class="header-cell">
								{{ plan }}
							</div>
						</div>
					</div>
					<div class="table-body">
						<template v-for="(section, sectionIndex) in sections" :key="section.title">
							<div class="section-row" @click="toggleSection(sectionIndex)">
								<div class="section-title">
									<div class="section-header">
										<button class="section-toggle" :class="{ 'collapsed': collapsedSections[sectionIndex] }">
											<svg class="chevron-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M6 9.5L12 15.5L18 9.5" stroke="#111111" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>
											</svg>
										</button>
										<span>{{ section.title }}</span>
									</div>
								</div>
							</div>
							<template v-if="!collapsedSections[sectionIndex]">
								<div v-for="feature in section.features" :key="section.title + feature.name" class="feature-row">
									<div class="feature-name">
										{{ feature.name }}
										<InfoTooltip v-if="feature.tooltip" :text="feature.tooltip" position="right" />
									</div>
									<div v-for="(value, idx) in feature.values" :key="feature.name + idx" class="feature-value">
										<template v-if="feature.isChecklist && value === 'true'">
											<img src="@/assets/checkmark.svg" alt="✓" class="checkmark-icon" />
										</template>
										<template v-else-if="feature.isChecklist && value === ''">
											<span class="empty-value">–</span>
										</template>
										<template v-else>
											{{ value }}
										</template>
									</div>
								</div>
							</template>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
	</teleport>
</template>

<script>
import comparisonData from "@/data/featureComparison.json";
import TrackingHelpers from "@/functions/tracking";
import InfoTooltip from "@/components/Tooltip.vue";

export default {
	name: "FeatureComparisonModal",
	components: {
		InfoTooltip
	},
	props: {
		open: {
			type: Boolean,
			default: false
		}
	},
	setup() {
		return { TrackingHelpers }
	},
	data() {
		return {
			plans: comparisonData.plans,
			sections: comparisonData.sections,
			collapsedSections: {}
		};
	},
	methods: {
		toggleSection(sectionIndex) {
			this.collapsedSections[sectionIndex] = !this.collapsedSections[sectionIndex];
		},
		disableBodyScroll() {
			document.body.style.overflow = 'hidden';
			document.body.style.position = 'fixed';
			document.body.style.width = '100%';
		},
		enableBodyScroll() {
			document.body.style.overflow = '';
			document.body.style.position = '';
			document.body.style.width = '';
		}
	},
	watch: {
		open(newVal) {
			if (newVal) {
				this.disableBodyScroll();
			} else {
				this.enableBodyScroll();
			}
		}
	},
	mounted() {
		// Initialize all sections as expanded by default
		this.sections.forEach((_, index) => {
			this.collapsedSections[index] = false;
		});
		
		// If modal is open on mount, disable body scroll
		if (this.open) {
			this.disableBodyScroll();
		}
	},
	beforeUnmount() {
		// Ensure body scroll is re-enabled when component is destroyed
		this.enableBodyScroll();
	}
};
</script>

<style scoped>
/* Prevent scrolling on the modal content itself */
.feature-comparison-modal-container::-webkit-scrollbar {
	width: 8px;
}

.feature-comparison-modal-container::-webkit-scrollbar-track {
	background: #f1f1f1;
	border-radius: 4px;
}

.feature-comparison-modal-container::-webkit-scrollbar-thumb {
	background: #c1c1c1;
	border-radius: 4px;
}

.feature-comparison-modal-container::-webkit-scrollbar-thumb:hover {
	background: #a8a8a8;
}
</style>